module.exports = __webpack_public_path__ + "static/media/charityImg_3.1b8a24ad.png";